import {
  Field,
  FieldDescription,
  FieldGroup,
  FieldLegend,
  FieldSeparator,
  FieldSet,
} from "@/client/components/shad/field";
import { withForm } from "../../form-context";
import { mapFormOptions } from "../shared";

export const SatelliteMapURLBlock = withForm({
  ...mapFormOptions,
  render: function Render({ form }) {
    return (
      <FieldSet>
        <FieldLegend>Satellite Map Source</FieldLegend>
        <FieldDescription>
          Satellite imagery URL for aerial map views. Requires an online
          provider and may not work offline. Can be toggled on or off.
        </FieldDescription>

        <FieldGroup>
          <Field>
            <form.AppField name="showSatellite">
              {(field) => (
                <field.SwitchField
                  trueLabel="Satellite map enabled"
                  falseLabel="Satellite map disabled"
                />
              )}
            </form.AppField>
          </Field>
          <FieldSeparator />
          <Field>
            <form.AppField name="satelliteMapUrl">
              {(field) => <field.TextField label="Satellite map URL" />}
            </form.AppField>
          </Field>
        </FieldGroup>
      </FieldSet>
    );
  },
});
